import { Component, OnInit, Input} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AppService } from '../../services/app.service'

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit {
  @Input() config;
  @Input() data;
  activeImageIndex: number = 0;
  constructor(private _sanitizer: DomSanitizer, private appService: AppService) { }

  ngOnInit() {
    let path: Array<string>;
    if (this.config.hasOwnProperty('mapping')) {
      if (this.config.mapping.hasOwnProperty('imagesKey')) {
        path = this.config.mapping.imagesKey.split('.');
        this.config.images = this.appService.findObjectByPath(this.data, path);
      }
    }
    this.setActiveImage(0);
  }

  /**
   * [Triggred when a segment is clicked]
   * @param  $event [segment value change event]
   * @return        [void]
   * @author Neil
   */
  segmentChanged($event) {
    this.setActiveImage($event.detail.value);
  }

  /**
   * [Set index of the active image to be shown in the preview div]
   * @param  index [index of the active image in config.images]
   * @return        [void]
   * @author Neil
   */
  setActiveImage(index: number) {
    this.activeImageIndex = index;
  }

  /**
   * [return the url of the currentActiveImage]
   * @return        [url string]
   * @author Neil
   */
  getActiveImage():string {
    return this.config.images[this.activeImageIndex].url;
  }

  /**
   * [sanitize image urls before adding to the dom]
   * @param  url [image src url]
   * @author Neil
   * @return
   */
  santize(url: string) {
    return this._sanitizer.bypassSecurityTrustStyle(`url(${url})`);
  }
}
